import React from 'react';
import Button from '@mui/material/Button';

interface CustomButtonProps {
  label: string;
  onClick: () => void;
  variant?: 'text' | 'outlined' | 'contained';
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  disabled?: boolean;
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
  sx?: React.CSSProperties;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  label,
  onClick,
  variant = 'contained',
  color = 'primary',
  disabled = false,
  fullWidth = false,
  size = 'medium',
  sx,
}) => {
  return (
    <Button
      variant={variant}
      color={color}
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      sx={sx}
    >
      {label}
    </Button>
  );
};

export default CustomButton;
